import React from 'react';
import { OrderService, OrderSortBy, OrderStatus } from '../api';
import { OrdersTable } from './OrdersTable';

export const ArchivedOrders = () => {
  const opId = 'getArchivedOrders';
  const fetchingMethod = (
    page?: number,
    perPage?: number,
    search?: string,
    sortBy?: OrderSortBy,
    orderPageIds?: string[],
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    _statuses?: OrderStatus[],
  ) => OrderService.getArchivedOrders(page, perPage, search, sortBy, orderPageIds);
  return <OrdersTable fetchingMethod={fetchingMethod} opId={opId} hideActions withArchivedColumns />;
};
